import React, { useState } from 'react';
import { attractions } from '../mock';
import { ArrowUpRight } from 'lucide-react';

const Attractions = () => {
  const tags = ['Tutti', ...Array.from(new Set(attractions.map(a => a.tag)))];
  const [active, setActive] = useState('Tutti');
  const items = active === 'Tutti' ? attractions : attractions.filter(a => a.tag === active);

  return (
    <section id="attractions" className="bg-[#faf7f2] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-6">
          <div>
            <p className="text-[#C87355] text-xs tracking-[0.4em] uppercase mb-5">Territorio</p>
            <h2 className="font-serif text-[#1f1f1f] text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
              Artigianato,<br />
              <span className="italic text-[#3A4A2C]">musica</span> & tradizione.
            </h2>
          </div>

          <div className="flex flex-wrap gap-2">
            {tags.map(t => (
              <button
                key={t}
                onClick={() => setActive(t)}
                className={`px-4 py-2 text-[11px] tracking-[0.2em] uppercase border transition-colors duration-300 ${
                  active === t
                    ? 'bg-[#3A4A2C] border-[#3A4A2C] text-[#faf7f2]'
                    : 'border-[#3A4A2C]/30 text-[#3A4A2C] hover:border-[#3A4A2C]'
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {items.map(a => (
            <article key={a.id} className="group cursor-pointer">
              <div className="relative overflow-hidden mb-5">
                <img
                  src={a.image}
                  alt={a.title}
                  loading="lazy"
                  className="w-full h-72 object-cover group-hover:scale-110 transition-transform duration-[1200ms]"
                />
                <div className="absolute top-4 left-4 px-3 py-1 bg-[#faf7f2]/95 text-[#3A4A2C] text-[10px] tracking-[0.25em] uppercase">
                  {a.tag}
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors"></div>
                <div className="absolute bottom-4 right-4 w-11 h-11 rounded-full bg-[#faf7f2] flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                  <ArrowUpRight size={18} className="text-[#3A4A2C]" />
                </div>
              </div>
              <h3 className="font-serif text-[#1f1f1f] text-2xl mb-3 group-hover:text-[#3A4A2C] transition-colors">{a.title}</h3>
              <p className="text-[#666] text-sm leading-relaxed">{a.excerpt}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Attractions;
